export const ThemeColors = {
  green: 'green',
  blue: 'blue',
  yellow: 'yellow',
  purple: 'purple',
} as const;

export type ThemeColor = (typeof ThemeColors)[keyof typeof ThemeColors];
